/* eslint-disable react/jsx-key */
import React, { lazy } from "react";
import AuthorizedRoute from "base-shell/lib/components/AuthorizedRoute";
import UnauthorizedRoute from "base-shell/lib/components/UnauthorizedRoute";
import PasswordConfirm from "../pages/PasswordReset/PasswordConfirm";

const SignIn = lazy(() => import("../pages/SignIn/SignIn"));

const SignUp = lazy(() => import("../pages/SignUp/SignUp"));
const PasswordReset = lazy(() =>
    import("../pages/PasswordReset/PasswordReset")
);
const About = lazy(() => import("../pages/About"));
const Home = lazy(() => import("../pages/Home/Home"));
const DialogDemo = lazy(() => import("../pages/DialogDemo/DialogDemo"));
const ToastDemo = lazy(() => import("../pages/ToastDemo/ToastDemo"));
const FilterDemo = lazy(() => import("../pages/FilterDemo"));
const ListPageDemo = lazy(() => import("../pages/ListPageDemo"));
const TabsDemo = lazy(() => import("../pages/TabsDemo"));
const MyAccount = lazy(() => import("../pages/MyAccount/MyAccount"));
const Tramite = lazy(() => import("../pages/Tramite/Tramite"));
const Solicitud = lazy(() => import("../pages/Solicitud/Solicitud"));
const SolicitudAdministrar = lazy(() =>
    import("../pages/Solicitud/Administrar")
);
const Revision = lazy(() => import("../pages/Revision/Revision"));
const Content = lazy(() => import("../pages/LandingPage/Parts/Content"));
const Servicios = lazy(() => import("../pages/Solicitud/Servicios"));
const DocumentoAdministrar = lazy(() =>
    import("../pages/documentos/Administrar")
);
const Comprobante = lazy(() => import("../pages/pago/Comprobante"));
const routes = [
    {
        path: "/signin",
        exact: true,
        element: (
            <UnauthorizedRoute>
                <SignIn redirectTo="/home" />
            </UnauthorizedRoute>
        ),
    },
    {
        path: "/signup",
        exact: true,
        element: (
            <UnauthorizedRoute>
                <SignUp redirectTo="/home" />
            </UnauthorizedRoute>
        ),
    },
    {
        path: "/password_reset",
        exact: true,
        element: (
            <UnauthorizedRoute>
                <PasswordReset redirectTo="/home" />
            </UnauthorizedRoute>
        ),
    },
    {
        path: "/password_confirm/:token",
        exact: true,
        element: (
            <UnauthorizedRoute>
                <PasswordConfirm redirectTo="/home" />
            </UnauthorizedRoute>
        ),
    },
    {
        path: "/about",
        exact: true,
        element: <About />,
    },
    {
        path: "/my_account",
        exact: true,
        element: (
            <AuthorizedRoute>
                <MyAccount />
            </AuthorizedRoute>
        ),
    },
    {
        path: "/home",
        exact: true,
        element: (
            <AuthorizedRoute>
                <Home />
            </AuthorizedRoute>
        ),
    },
    {
        path: "/dialog_demo",
        exact: true,
        element: (
            <AuthorizedRoute>
                <DialogDemo />
            </AuthorizedRoute>
        ),
    },
    {
        path: "/toast_demo",
        exact: true,
        element: (
            <AuthorizedRoute>
                <ToastDemo />
            </AuthorizedRoute>
        ),
    },
    {
        path: "/filter_demo",
        exact: true,
        element: (
            <AuthorizedRoute>
                <FilterDemo />
            </AuthorizedRoute>
        ),
    },
    {
        path: "/list_page_demo",
        exact: true,
        element: (
            <AuthorizedRoute>
                <ListPageDemo />
            </AuthorizedRoute>
        ),
    },
    {
        path: "/tabs_demo",
        exact: true,
        element: (
            <AuthorizedRoute>
                <TabsDemo />
            </AuthorizedRoute>
        ),
    },
    {
        path: "/tramite/:id_tramite",
        exact: true,
        element: <Tramite />,
    },
    {
        path: "/solicitud/:id_tramite",
        exact: true,
        element: (
            <AuthorizedRoute>
                <Solicitud />
            </AuthorizedRoute>
        ),
    },
    {
        path: "/solicitud/rev/:id_solicitud",
        exact: true,
        element: (
            <AuthorizedRoute>
                <Solicitud />
            </AuthorizedRoute>
        ),
    },
    {
        path: "/solicitud_administrar",
        exact: true,
        element: (
            <AuthorizedRoute>
                <SolicitudAdministrar />
            </AuthorizedRoute>
        ),
    },
    {
        path: "/servicios",
        exact: true,
        element: (
            <AuthorizedRoute>
                <Servicios />
            </AuthorizedRoute>
        ),
    },
    {
        path: "/revision/:id_solicitud",
        exact: true,
        element: (
            <AuthorizedRoute>
                <Revision />
            </AuthorizedRoute>
        ),
    },
    {
        path: "/documentos/:id_solicitud",
        exact: true,
        element: (
            <AuthorizedRoute>
                <DocumentoAdministrar />
            </AuthorizedRoute>
        ),
    },
    {
        path: "/comprobante/:id_solicitud",
        exact: true,
        element: (
            <AuthorizedRoute>
                <Comprobante />
            </AuthorizedRoute>
        ),
    },
];

export default routes;
